
<template>
  <v-card>
    <v-card-text>
      <v-list two-line>
        <template v-for="(item, index) in logs">
          <v-list-item :key="item.id" avatar ripple>
            <v-list-item-content>
              <v-list-item-title class="text--primary">{{
                item.created_at + " - " +
                  item.description
              }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.notes }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index + 1 < logs.length" :key="index"></v-divider>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'BillLogs',
  props: {
    logs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {

    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null
    },
    ...mapState({
    })
  },
  watch: {
    data(nv, ov) {
      if (nv) {
      } else if (nv == false) {
      }
    }
  },
}
</script>

<style scoped>

</style>